import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildSalesforceParamsQuery } from '../../utils/methods';
import request from '../../modules/Request/request';

export const getGeneralDetails = createAsyncThunk(
  'getGeneralDetails',
  async (object, { rejectWithValue }) => {
    try {
      const { accountId } = object;
      const query = { page: 'account', accountId };
      const finalQuery = buildSalesforceParamsQuery(query, object);
      const response = await request('/general-detail', { method: 'GET', query: finalQuery });
      if (response.success) return response.data;
      throw new Error(response.error?.message || response.error || 'Something went wrong');
    } catch (err) {
      return rejectWithValue(err.message || 'Something went wrong');
    }
  },
);

export const updateAccount = createAsyncThunk(
  'updateAccount',
  async ({ orgId, licenseId, newData }, { rejectWithValue }) => {
    const response = await request('/update-account', { method: 'PUT', body: newData, params: [orgId, licenseId] });
    if (response.success) return newData;
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);

export const getAllRemarks = createAsyncThunk(
  'getAllRemarks',
  async (object, { rejectWithValue }) => {
    const { accountId } = object;
    const finalQuery = buildSalesforceParamsQuery({}, object);
    const response = await request('/get-remarks', { method: 'GET', query: finalQuery, params: [accountId] });
    if (response.success) return response.data;
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },

);

export const saveRemarks = createAsyncThunk(
  'saveRemarks',
  async ({ accountId, licenseId, body }, { rejectWithValue }) => {
    const response = await request('/remarks', { method: 'POST', body, params: [accountId, licenseId] });
    if (response.success) {
      return response.data;
    }

    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
